<template>
  <div class="header-mobile-menu__wrapper">
    <div class="header-mobile-menu__icon-wrapper" @click="toggleMenu">
      <a-icon
        :icon="currentIcon"
        :no-hover="true"
        :original="true"
        :width="24"
        :height="24"
        class="header-mobile-menu__icon"
      />
    </div>

    <a-header-mobile-menu-expanded v-model="isOpen" />
  </div>
</template>

<script>
import AIcon, { ICON } from 'shared/AIcon/index.vue'
import { hydrationHelpers } from '@/utils/mixins/hydrationHelpers'
import AHeaderMobileMenuExpanded from '@/components/_layout/AHeader/AHeaderMobileMenu/AHeaderMobileMenuExpanded/index.vue'

export default {
  name: 'AHeaderMobileMenu',
  mixins: [hydrationHelpers],
  components: { AHeaderMobileMenuExpanded, AIcon },
  data() {
    return {
      isOpen: false
    }
  },
  computed: {
    currentIcon() {
      return this.isOpen ? ICON.X_CLOSE : ICON.BURGER_MENU
    }
  },
  watch: {
    isOpen: {
      handler(newVal) {
        if (newVal) return this.$_hydrationHelpers_hideScroll()

        this.$_hydrationHelpers_showScroll()
      }
    }
  },
  methods: {
    toggleMenu() {
      this.isOpen = !this.isOpen
    }
  },
  beforeDestroy() {
    this.$_hydrationHelpers_showScroll()
  }
}
</script>

<style lang="scss" scoped>
.header-mobile-menu__wrapper {
  .header-mobile-menu__icon-wrapper {
    padding: 8px;
    width: 40px;
    height: 40px;
  }
}
</style>
